function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { openPinModal, setChannelSettings, setProfileSettings } from "@common/actions";
import Checkbox from "@common/components/Settings/ResetSettings/Checkbox";
import Section from "@common/components/Settings/ResetSettings/Section";
import SettingItem from "@common/components/Settings/SettingItem";
import SettingsModalContentWrapper from "@common/components/Settings/SettingsModalContentWrapper";
import { INITIAL_STATE } from "@common/reducers/profileSettings";
import { sort } from "@common/services/helpers";
import { changeWebSetting, convertToDeviceSettingsItemList } from "@common/utils/helpers";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_SUCCESS } from "@config/constants";
import { Button } from "@material-ui/core";
import { isEmpty, isEqual, isNil } from "lodash";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
var ResetSettings = /*#__PURE__*/ function(SettingItem) {
    "use strict";
    _inherits(ResetSettings, SettingItem);
    var _super = _create_super(ResetSettings);
    function ResetSettings(props) {
        _class_call_check(this, ResetSettings);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "resetGlobalSetting", function(resourceName) {
            var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
            // const { profileSettings } = this.props;
            _this.profileSettings = changeWebSetting(_this.profileSettings, _define_property({}, resourceName, value));
        });
        _define_property(_assert_this_initialized(_this), "resetChannelSetting", function() {
            var resourceName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "locked", forceSetValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
            var liveChannels = _this.props.liveChannels;
            var DeviceSettingsItemList = _this.profileSettings.web_settings.DeviceSettingsItemList.map(function(obj) {
                var value = forceSetValue !== undefined ? forceSetValue : liveChannels[obj.channelInfo.id][resourceName];
                return _object_spread_props(_object_spread({}, obj), {
                    channelSettings: _object_spread_props(_object_spread({}, obj.channelSettings), _define_property({}, resourceName, value))
                });
            });
            _this.profileSettings = changeWebSetting(_this.profileSettings, {
                DeviceSettingsItemList: DeviceSettingsItemList
            });
        });
        _define_property(_assert_this_initialized(_this), "resetChannelOrder", function() {
            var liveChannels = _this.props.liveChannels;
            var channels = Object.values(sort(liveChannels, false, false));
            var DeviceSettingsItemList = convertToDeviceSettingsItemList(channels, _this.profileSettings.web_settings.DeviceSettingsItemList);
            _this.profileSettings = changeWebSetting(_this.profileSettings, {
                DeviceSettingsItemList: DeviceSettingsItemList
            });
        });
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "save", /*#__PURE__*/ _async_to_generator(function() {
            var checked, _this_props, profileSettings, i18n, openModal, _$openPinModal, shouldRequirePin, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        checked = _this1.state.checked;
                        _this_props = _this1.props, profileSettings = _this_props.profileSettings, i18n = _this_props.i18n, openModal = _this_props.openModal, _$openPinModal = _this_props.openPinModal;
                        _this1.profileSettings = profileSettings;
                        if (!confirm(i18n.reset.areYouSureReset)) {
                            return [
                                2
                            ];
                        }
                        shouldRequirePin = checked.locked;
                        checked.order && _this1.resetChannelOrder();
                        checked.hidden && _this1.resetChannelSetting("visible");
                        checked.individualAudio && _this1.resetChannelSetting("audio", null);
                        checked.individualVideo && _this1.resetChannelSetting("resolution", null);
                        checked.individualSubtitles && _this1.resetChannelSetting("subtitles", null);
                        checked.globalAudio && _this1.resetGlobalSetting("audio", null);
                        checked.globalVideo && _this1.resetGlobalSetting("resolution", -1);
                        checked.globalSubtitles && _this1.resetGlobalSetting("subtitles", null);
                        checked.locked && _this1.resetChannelSetting("locked");
                        if (!shouldRequirePin) return [
                            3,
                            1
                        ];
                        _tmp = _$openPinModal({
                            onSuccess: /*#__PURE__*/ _async_to_generator(function() {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this1.handleSuccess()
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            shouldShowSnackbar: false,
                            shouldUnlock: false
                        });
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            _this1.handleSuccess()
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }));
        _define_property(_assert_this_initialized(_this), "successMessage", function() {
            return _this.props.enqueueSnackbar(_this.props.i18n.reset.successReset, {
                variant: SNACKBAR_VARIANT_SUCCESS,
                autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
            });
        });
        var _this2 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "handleSuccess", /*#__PURE__*/ _async_to_generator(function() {
            var _$setProfileSettings;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _$setProfileSettings = _this2.props.setProfileSettings;
                        return [
                            4,
                            _$setProfileSettings(_this2.profileSettings)
                        ];
                    case 1:
                        _state.sent();
                        _this2.toggleAll(false);
                        _this2.successMessage();
                        return [
                            2
                        ];
                }
            });
        }));
        _define_property(_assert_this_initialized(_this), "handleChange", function(name, checked) {
            _this.setState({
                checked: _object_spread_props(_object_spread({}, _this.state.checked), _define_property({}, name, checked))
            });
        });
        _define_property(_assert_this_initialized(_this), "checkIfAreAllSelected", function() {
            var checked = _this.state.checked;
            if (!checked) {
                return false;
            }
            var values = Object.values(_this.state.checked);
            return values.every(function(value) {
                return value === true;
            });
        });
        _define_property(_assert_this_initialized(_this), "toggleAll", function() {
            var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
            var checkState = _object_spread({}, _this.state.checked);
            var keys = Object.keys(checkState);
            var areAllSelected = _this.checkIfAreAllSelected();
            // Set all in true
            keys.forEach(function(key) {
                return checkState[key] = areAllSelected ? !checkState[key] : isNil(state) ? true : state;
            });
            _this.setState({
                checked: checkState
            });
        });
        _define_property(_assert_this_initialized(_this), "resetAll", function() {
            var _this_props = _this.props, i18n = _this_props.i18n, _$openPinModal = _this_props.openPinModal, liveChannels = _this_props.liveChannels, _$setProfileSettings = _this_props.setProfileSettings, settingsChannelsConfig = _this_props.settingsChannelsConfig, _$setChannelSettings = _this_props.setChannelSettings;
            if (!confirm(i18n.reset.areYouSureReset)) {
                return;
            }
            var _this1 = _assert_this_initialized(_this);
            _$openPinModal({
                onSuccess: /*#__PURE__*/ _async_to_generator(function() {
                    var profileSettings, channels, DeviceSettingsItemList;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                profileSettings = _object_spread({}, INITIAL_STATE);
                                channels = Object.values(sort(liveChannels, false, false));
                                DeviceSettingsItemList = convertToDeviceSettingsItemList(channels, profileSettings.web_settings.DeviceSettingsItemList);
                                return [
                                    4,
                                    _$setProfileSettings(changeWebSetting(profileSettings, {
                                        DeviceSettingsItemList: DeviceSettingsItemList
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _$setChannelSettings(settingsChannelsConfig, settingsChannelsConfig.defaultPIN)
                                ];
                            case 2:
                                _state.sent();
                                _this1.toggleAll(false);
                                _this1.successMessage();
                                return [
                                    2
                                ];
                        }
                    });
                }),
                shouldShowSnackbar: false,
                shouldUnlock: false
            });
        });
        _define_property(_assert_this_initialized(_this), "renderSaveButton", function() {
            return /*#__PURE__*/ _jsx(Button, {
                onClick: _this.save,
                disabled: isEqual(_this.state.checked, _this.initialCheckedState),
                children: _this.props.i18n.reset.resetSelected
            });
        });
        _define_property(_assert_this_initialized(_this), "renderLeftButton", function() {
            return /*#__PURE__*/ _jsxs(Button, {
                onClick: function() {
                    return _this.resetAll();
                },
                classes: {
                    label: "ux-button-label"
                },
                className: "go-back-button raised half-width",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "icon isa-icon isa_reset"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: _this.props.i18n.reset.resetAll
                    })
                ]
            });
        });
        _this.initialCheckedState = {
            order: false,
            hidden: false,
            locked: false,
            globalAudio: false,
            globalVideo: false,
            globalSubtitles: false,
            individualAudio: false,
            individualVideo: false,
            individualSubtitles: false
        };
        _this.profileSettings = _this.props.profileSettings;
        _this.state = _object_spread_props(_object_spread({}, _this.state), {
            saveButtonDisabled: true,
            checked: _this.initialCheckedState
        });
        _this.saveButtonTitle = _this.props.i18n.settings.resetChannelSettings;
        return _this;
    }
    _create_class(ResetSettings, [
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                var i18nReset = i18n.reset;
                var checked = this.state.checked;
                var commonProps = {
                    checked: checked,
                    onChange: this.handleChange
                };
                return /*#__PURE__*/ _jsxs(SettingsModalContentWrapper, {
                    title: i18n.settings.resetViewTitle,
                    children: [
                        /*#__PURE__*/ _jsxs(Section, {
                            title: i18nReset.channelSettings,
                            subtitle: i18nReset.channelSettingsSub,
                            children: [
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.reorder,
                                    name: "order"
                                }, commonProps)),
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.hide,
                                    name: "hidden"
                                }, commonProps)),
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.lock,
                                    name: "locked"
                                }, commonProps))
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Section, {
                            title: i18nReset.globalSetting,
                            subtitle: i18nReset.globalSettingSub,
                            children: [
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.audio,
                                    name: "globalAudio"
                                }, commonProps)),
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.video,
                                    name: "globalVideo"
                                }, commonProps)),
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.subtitles,
                                    name: "globalSubtitles"
                                }, commonProps))
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Section, {
                            title: i18nReset.individualSettings,
                            subtitle: i18nReset.individualSettingsSub,
                            children: [
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.audio,
                                    name: "individualAudio"
                                }, commonProps)),
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.video,
                                    name: "individualVideo"
                                }, commonProps)),
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.subtitles,
                                    name: "individualSubtitles"
                                }, commonProps))
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Section, {
                            title: i18nReset.accessability,
                            subtitle: i18nReset.accessabilitySub,
                            children: [
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.accessabilityAudio,
                                    name: "accessabilityAudio"
                                }, commonProps)),
                                /*#__PURE__*/ _jsx(Checkbox, _object_spread({
                                    title: i18nReset.accessabilitySubtitles,
                                    name: "individualSubtitles"
                                }, commonProps))
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ResetSettings;
}(SettingItem);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings, liveChannels = param.liveChannels, settingsChannelsConfig = param.settingsChannelsConfig;
    return {
        i18n: i18n,
        profileSettings: profileSettings,
        liveChannels: liveChannels,
        settingsChannelsConfig: settingsChannelsConfig
    };
};
var connected = connect(mapStateToProps, {
    setProfileSettings: setProfileSettings,
    setChannelSettings: setChannelSettings,
    openPinModal: openPinModal
})(ResetSettings);
export default withSnackbar(connected);
